module.exports = __webpack_public_path__ + "media/images/smart_phone/toplogo_11-8876a5f913a6fd5a332d218d71c59bb1.png";